// extracted by mini-css-extract-plugin
module.exports = {"slideContent":"ConcertMediaScreen-module__slideContent___2_4wA"};